import QuantityBasicSelector from '@/components/QuantitySelector/QuantityBasicSelector.vue';
import QuantityBulkSelector from '@/components/QuantitySelector/QuantityBulkSelector.vue';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown.js';
import { useProductStore } from '@/shared/pinia/modules/product';
import { useProductOptionsStore } from '@/shared/pinia/modules/product-options';
import { useProductQuantitiesStore } from '@/shared/pinia/modules/product-quantities';
import { getBulkDiscounts } from '@/shared/utils/discounts';
import { setupI18n } from '@/shared/utils/i18n';

export const initQuantitySelector = async (createApp, mountSelector) => {
  const script = document.getElementById(mountSelector);

  if (!script) return;

  const quantityStore = useProductQuantitiesStore();
  const optionsStore = useProductOptionsStore();
  const productStore = useProductStore();

  const price = Number(script.dataset.price);
  const compareAtPrice = Number(script.dataset.compareAtPrice ?? null);
  const hasDifferentPrices = script.dataset.hasDifferentPrices === 'true';

  if (price) {
    productStore.price.initial_unit = price;
    productStore.price.unit = price;
  }

  const isOnSale = compareAtPrice > price;
  if (isOnSale) {
    productStore.price.savings = compareAtPrice - price;
    productStore.price.before = compareAtPrice;
  }
  const hasBulkDiscountsConfig = !!script.dataset.discounts;
  const useBulkDiscounts = !isOnSale && hasBulkDiscountsConfig;

  const bulkDiscounts = useBulkDiscounts
    ? getBulkDiscounts(script.dataset.discounts, price)
    : [];

  quantityStore.setBulkDiscounts(bulkDiscounts);

  const quantityComponent = useBulkDiscounts
    ? QuantityBulkSelector
    : QuantityBasicSelector;
  const defaultValue = useBulkDiscounts ? 0 : 1;

  const vueApp = createApp(quantityComponent);

  quantityStore.quantity = defaultValue;
  optionsStore.haveDifferentPrices = hasDifferentPrices;

  const i18n = await setupI18n(window.Shopify.locale);

  vueApp.use(window.hobbiiStore);

  vueApp
    .use(i18n)
    .directive('global-keydown', GlobalKeyDownDirective)
    .mount(`#${mountSelector}`);

  // TODO update stock
};
